/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ModelsAccountStatus {
  AccountStatusActive = 'ACTIVE',
  AccountStatusInactive = 'INACTIVE',
  AccountStatusBlocked = 'BLOCKED',
  AccountStatusPendingAdminApprove = 'PENDING_ADMIN_APPROVE',
  AccountStatusPendingApproveTransaction = 'PENDING_APPROVE_TRANSACTION',
  AccountStatusVerified = 'VERIFIED',
  AccountStatusPendingDataSubmission = 'PENDING_DATA_SUBMISSION',
  AccountStatusRejected = 'REJECTED',
  AccountStatusChangesRequested = 'CHANGES_REQUESTED',
  AccountStatusDraft = 'DRAFT',
  AccountStatusPendingModeration = 'PENDING_MODERATION',
  AccountStatusNeedsRevision = 'NEEDS_REVISION',
  AccountStatusInEdit = 'IN_EDIT',
  AccountStatusDeleted = 'DELETED',
  AccountStatusUnknown = 'UNKNOWN'
}

export interface ModelsActionAttemptResponse {
  attempt_expires_at?: string
  failure_reason?: string
  platform?: string
  state?: string
  steps?: {
    install?: string
    sign_up?: string
  }
  ui_status?: string
}

export interface ModelsActionStoreLinkRequest {
  platform: 'app_store' | 'google_play'
}

export interface ModelsActionStoreLinkResponse {
  attempt_expires_at?: string
  state?: string
  url?: string
}

export enum ModelsActionType {
  ActionTypeSignUp = 'SIGN_UP',
  ActionTypeLogIn = 'LOG_IN',
  ActionTypeRecoveryPassword = 'RECOVERY_PASSWORD',
  ActionTypeUpdateEmail = 'UPDATE_EMAIL',
  ActionTypeDeleteAccount = 'DELETE_ACCOUNT',
  ActionTypeUpdatePassword = 'UPDATE_PASSWORD',
  ActionTypeAttachEmail = 'ATTACH_EMAIL'
}

export interface ModelsAddNewsLikeRequest {
  news_id: string
}

export interface ModelsAgent {
  /** From User */
  avatar_url?: string
  /** From User */
  banner_url?: string
  bio?: string
  /** From User */
  city?: string
  /** From User */
  country?: string
  country_flag_url?: string
  country_name?: string
  created_at?: string
  description?: string
  email?: string
  /** From User */
  favorite_sport_type?: ModelsSportType
  id?: string
  invited_by_agent_id?: string
  /** From User */
  is_wallet_connected?: boolean
  /** Username from User */
  name?: string
  phone_number?: string
  /** From User */
  status?: string
  telegram_url?: string
  twitter_url?: string
  updated_at?: string
  user_id?: string
  /** From User */
  wallet_address?: string
}

export interface ModelsAgentEarningsResponse {
  available_to_receive?: string
  pending?: string
  total_earned?: string
}

export interface ModelsAgentPayout {
  agent_id?: string
  amount?: string
  club_id?: string
  created_at?: string
  followers_snapshot?: number
  id?: string
  status?: string
  tier_id?: string
  updated_at?: string
}

export interface ModelsAgentPayoutsResponse {
  page?: number
  page_size?: number
  payouts?: ModelsAgentPayout[]
  total?: number
}

export interface ModelsAgentProfileResponse {
  agent?: ModelsAgent
  earnings?: ModelsAgentEarningsResponse
  recruited_agents?: ModelsGetAgentReferralsResponse
  recruited_clubs?: ModelsListClubsResponse
  referral_codes?: ModelsReferralCode[]
}

export interface ModelsAgentReferral {
  entity_type?: string
  user?: ModelsUser
}

export interface ModelsAgentResponse {
  agent?: ModelsAgent
}

export interface ModelsAttachUserEmailRequest {
  email: string
  /** @min 0 */
  verification_code: number
  verification_id: string
}

export interface ModelsChallengesStatsResponse {
  completed_challenges_count?: number
}

export interface ModelsCheckUserExistsByEmailResponse {
  is_exists?: boolean
}

export interface ModelsCheckUserExistsByUsernameResponse {
  is_exists?: boolean
}

export interface ModelsCityFullInfo {
  /**
   * AdminName is the region / state of a search result (BAT-1166), to tell
   * same-named places apart.
   */
  admin_name?: string
  country_code?: string
  country_id?: number
  created_at?: string
  flag?: number
  id?: number
  latitude?: number
  level?: number
  longitude?: number
  name?: string
  native?: string
  parent_id?: number
  population?: number
  state_code?: string
  state_id?: number
  timezone?: string
  translations?: string
  type?: string
  updated_at?: string
  wiki_data_id?: string
}

export interface ModelsClub {
  abbreviated_name?: string
  city?: string
  club_image?: string
  club_name?: string
  country?: string
  created_at?: string
  description?: string
  facebook_url?: string
  fan_count?: number
  fan_count_minimum?: boolean
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  id?: string
  instagram_url?: string
  invited_by_agent_id?: string
  /** Effective Verified mark: a manual admin flag on a live club or athlete */
  is_verified?: boolean
  is_wallet_connected?: boolean
  other_url?: string
  phone_number?: string
  professional_level?: string
  rank?: number
  /** BAT-835: region (state) of the picked city */
  region?: string
  social_proof_submitted?: boolean
  social_proof_url?: string
  sport?: ModelsPublicSportType
  sport_type?: string
  status?: ModelsAccountStatus
  tiktok_url?: string
  twitter_url?: string
  updated_at?: string
  user_id?: string
  wallet_address?: string
  website_url?: string
  youtube_url?: string
}

export interface ModelsClubApplication {
  abbreviated_name?: string
  admin_comment?: string
  application_id?: string
  city?: string
  /** Detailed description of the club */
  club_description?: string
  club_id?: string
  club_logo_url?: string
  club_name?: string
  country?: string
  created_at?: string
  facebook_url?: string
  /** Full name of the club contact person */
  fullname?: string
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  instagram_url?: string
  legal_documents_url?: string
  other_url?: string
  /** Phone number of the club contact person */
  phone_number?: string
  /** PROFESSIONAL, AMATEUR */
  professional_level?: ModelsProfessionalLevel
  /** BAT-835: region (state) of the picked city */
  region?: string
  review_issues?: ModelsReviewIssue[]
  /** Role of the contact person in the club */
  role?: string
  /** FOOTBALL, BASKETBALL, AMERICAN_FOOTBALL */
  sport_type?: ModelsSportType
  /** PENDING, APPROVED, REJECTED, CHANGES_REQUESTED */
  status?: string
  tiktok_url?: string
  twitter_url?: string
  updated_at?: string
  website_url?: string
  youtube_url?: string
}

export interface ModelsClubApplicationDraftResponse {
  abbreviated_name?: string
  city?: string
  club_description?: string
  club_id?: string
  club_logo_url?: string
  club_name?: string
  country?: string
  facebook_url?: string
  fullname?: string
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  id?: string
  instagram_url?: string
  legal_documents_url?: string
  other_url?: string
  phone_number?: string
  professional_level?: string
  /** BAT-835: region (state) of the picked city */
  region?: string
  role?: string
  sport_type?: string
  tiktok_url?: string
  twitter_url?: string
  website_url?: string
  youtube_url?: string
}

export interface ModelsClubProfileResponse {
  /** Owner only: activation steps */
  activation_progress?: ModelsProgressStep[]
  /** ap_score from clubs_metrics */
  balance_pts?: number
  /** tasks_success_count from clubs_metrics */
  challenges_completed?: number
  club?: ModelsClub
  /** Rank within club's sport from clubs_metrics */
  club_rank?: number
  /** total_views from clubs_metrics */
  fan_views?: number
  /** Rank across all sports from clubs_metrics */
  global_rank?: number
  is_owner?: boolean
}

export interface ModelsClubResponse {
  club?: ModelsClub
}

export interface ModelsClubWaitlistRequestResponse {
  city?: string
  club_name?: string
  country?: string
  created_at?: string
  id?: string
  is_other_sport?: boolean
  location?: string
  other_sport_name?: string
  sport_type_id?: string
  updated_at?: string
  website?: string
}

export interface ModelsClubsLeaderboardClub {
  country?: string
  id?: string
  logo_url?: string
  name?: string
  sport?: ModelsPublicSportType
  sport_type?: string
}

export interface ModelsClubsLeaderboardEntry {
  ap_score?: number
  club?: ModelsClubsLeaderboardClub
  fans?: number
  rank?: number
  rank_change_daily?: number
  total_views?: number
}

export interface ModelsClubsLeaderboardResponse {
  applied_region?: string
  entries?: ModelsClubsLeaderboardEntry[]
  page?: number
  page_size?: number
  previous_snapshot_available?: boolean
  total_count?: number
}

export type ModelsCompleteActivityRequest = object

export interface ModelsCompleteActivityResponse {
  /** @example 100 */
  earned_pts?: number
}

export interface ModelsCompleteGoogleSignupRequest {
  entity_type: 'USER' | 'CLUB'
  google_signup_token: string
  /** $!{tid} from the landing URL — conversion tracking */
  tracking_token?: string
}

export interface ModelsCompleteWatchTaskRequest {
  /** @min 1 */
  total_seconds: number
  /** @min 0 */
  watched_seconds?: number
}

export interface ModelsCompleteWatchTaskResponse {
  completed?: boolean
  state?: string
}

export interface ModelsConnectExternalServiceRequest {
  code?: string
}

export interface ModelsConnectedServiceEntry {
  connected_at?: string
  service?: string
}

export interface ModelsConnectedServicesResponse {
  services?: ModelsConnectedServiceEntry[]
}

export interface ModelsCountry {
  code?: string
  flag_emoji?: string
  flag_url?: string
  name?: string
}

export interface ModelsCountryFullInfo {
  iso2?: string
  iso3?: string
  area_sq_km?: number
  capital?: string
  created_at?: string
  currency?: string
  currency_name?: string
  currency_symbol?: string
  emoji?: string
  emoji_u?: string
  flag?: number
  gdp?: number
  id?: number
  latitude?: number
  longitude?: number
  name?: string
  nationality?: string
  native?: string
  numeric_code?: string
  phone_code?: string
  population?: number
  postal_code_format?: string
  postal_code_regex?: string
  region?: string
  region_id?: number
  subregion?: string
  subregion_id?: number
  timezones?: string
  tld?: string
  translations?: string
  updated_at?: string
  wiki_data_id?: string
}

export interface ModelsCountryResponse {
  countries?: ModelsCountry[]
}

export interface ModelsCreateSupportTicketRequest {
  message: string
}

export interface ModelsDLQBatchItemResult {
  error?: string
  id?: string
  success?: boolean
}

export interface ModelsDLQBatchRequest {
  dryRun?: boolean
  ids?: string[]
  resolveNote?: string
}

export interface ModelsDLQBatchResponse {
  replayedCount?: number
  results?: ModelsDLQBatchItemResult[]
}

export interface ModelsDLQListResponse {
  messages?: ModelsDLQMessage[]
  nextPageToken?: string
  totalCount?: number
}

export interface ModelsDLQMessage {
  errorClass?: string
  errorMessage?: string
  errorStack?: string
  headers?: Record<string, any>
  id?: string
  messageKey?: number[]
  messageValue?: number[]
  receivedAt?: string
  resolveNote?: string
  resolvedAt?: string
  resolvedBy?: string
  sourceOffset?: number
  sourcePartition?: number
  sourceService?: string
  sourceTopic?: string
  status?: string
}

export interface ModelsDLQStats {
  discardedLast30d?: number
  replayedLast30d?: number
  byErrorClass?: Record<string, number>
  oldestPendingAgeSecs?: number
  pendingCount?: number
}

export interface ModelsDisconnectExternalServiceResponse {
  disconnected?: boolean
}

export interface ModelsEmailVerificationRequest {
  action_type: ModelsActionType
  email: string
}

export interface ModelsEmailVerificationResponse {
  verification_id?: string
}

export enum ModelsEntityType {
  EntityTypeUser = 'USER',
  EntityTypeClub = 'CLUB'
}

export interface ModelsFanReferralEntry {
  date_active?: string
  date_joined?: string
  earned_points?: number
  nickname?: string
  referral_id?: string
  referred_user_id?: string
}

export interface ModelsFanReferralLinkResponse {
  code?: string
  created_at?: string
  link?: string
}

export interface ModelsFanReferralStatsResponse {
  total_invited?: number
  total_pts_earned?: number
}

export interface ModelsFansLeaderboardItem {
  arena_points?: number
  avatar_url?: string
  avg_views?: number
  best_submitted_url?: string
  best_task_progress_id?: string
  best_views?: number
  club_id?: string
  club_logo_url?: string
  club_name?: string
  country?: string
  full_name?: string
  location?: string
  nickname?: string
  rank?: number
  rank_change_daily?: number
  tasks_success_count?: number
  total_views?: number
  user_id?: string
}

export interface ModelsFansLeaderboardPositionResponse {
  rank?: number
  rank_change_daily?: number
  tasks_success_count?: number
  total?: number
  total_views?: number
}

export interface ModelsFansLeaderboardResponse {
  applied_region?: string
  items?: ModelsFansLeaderboardItem[]
  page?: number
  page_size?: number
  previous_snapshot_available?: boolean
  total?: number
}

export interface ModelsFavoriteClub {
  favorite_club_city?: string
  favorite_club_country?: string
  favorite_club_fan_count?: number
  favorite_club_image_url?: string
  favorite_club_name?: string
  favorite_club_rank?: number
  /** External fields */
  id?: string
  /** Effective Verified mark of the favourite (a live, verified profile) */
  is_verified?: boolean
}

export interface ModelsFeaturedClub {
  ap_score?: number
  country?: string
  fan_count?: number
  id?: string
  joined_at?: string
  logo_url?: string
  name?: string
  sport?: ModelsPublicSportType
  sport_type?: string
}

export enum ModelsFileFormat {
  FileFormatJPG = 'jpg',
  FileFormatJPEG = 'jpeg',
  FileFormatPNG = 'png',
  FileFormatGIF = 'gif',
  FileFormatSVG = 'svg',
  FileFormatPDF = 'pdf',
  FileFormatDOCX = 'docx',
  FileFormatDOC = 'doc',
  FileFormatTXT = 'txt'
}

export enum ModelsFileType {
  FileTypeAvatar = 'avatar',
  FileTypeBanner = 'banner',
  FileTypeDocument = 'document'
}

export interface ModelsGenerateClubFileUploadURLRequest {
  file_format:
    | 'jpg'
    | 'jpeg'
    | 'png'
    | 'gif'
    | 'svg'
    | 'pdf'
    | 'docx'
    | 'doc'
    | 'txt'
  file_size: number
  file_type: 'avatar' | 'banner' | 'document'
}

export interface ModelsGenerateImageUploadURLRequest {
  image_format: ModelsImageFormat
  image_type: ModelsImageType
}

export interface ModelsGenerateImageUploadURLResponse {
  /** URL expiration time in seconds */
  expires_in?: number
  /** Final public URL to save in database */
  public_url?: string
  /** Headers the client must send with the presigned PUT (part of the signature) */
  upload_headers?: Record<string, string>
  /** Presigned URL for uploading the image */
  upload_url?: string
}

export interface ModelsGetAgentReferralsResponse {
  referrals?: ModelsAgentReferral[]
  total?: number
}

export interface ModelsGetAllNewsRecommendedResponse {
  recommended?: ModelsNewsRecommendedWithNews[]
}

export interface ModelsGetAllNewsMainPageResponse {
  main_pages?: ModelsNewsMainPageWithNews[]
  total_count?: number
}

export interface ModelsGetCampaignLeaderboardResponse {
  entries?: ModelsTasksLeaderboardEntry[]
  total?: number
}

export interface ModelsGetFeaturedClubsResponse {
  clubs?: ModelsFeaturedClub[]
}

export interface ModelsGetNewsByIDResponse {
  news?: ModelsNews
}

export interface ModelsGetNewsFavoriteResponse {
  favorite?: ModelsNewsFavoriteWithNews
}

export interface ModelsGetPlayerQuestsResponse {
  daily?: ModelsQuest[]
  season?: ModelsQuest[]
  weekly?: ModelsQuest[]
}

export interface ModelsGetUserBalanceResponse {
  balances?: ModelsUserBalance
  user_id?: string
}

export interface ModelsHandleGoogleCallbackRequest {
  code: string
  entity_type?: ModelsEntityType
  state: string
}

export interface ModelsHandleGoogleCallbackResponseV2 {
  access_token?: string
  entity_id?: string
  entity_type?: string
  google_signup_token?: string
  /** sign-up only, see VerifySignatureResponse */
  referral_type?: string
  refresh_token?: string
  requires_role_selection?: boolean
  status?: ModelsAccountStatus
  user?: ModelsUser
  username?: string
}

export enum ModelsImageFormat {
  ImageFormatJPG = 'jpg',
  ImageFormatJPEG = 'jpeg',
  ImageFormatPNG = 'png',
  ImageFormatGIF = 'gif',
  ImageFormatSVG = 'svg'
}

export enum ModelsImageType {
  ImageTypeAvatar = 'avatar',
  ImageTypeBanner = 'banner'
}

export interface ModelsInitGoogleOAuthResponse {
  auth_url?: string
}

export interface ModelsListAgentsResponse {
  agents?: ModelsAgent[]
  total?: number
}

export interface ModelsListAvailableTasksResponse {
  tasks?: ModelsTaskCard[]
  total?: number
}

export interface ModelsListClubsResponse {
  clubs?: ModelsClub[]
  total?: number
}

export interface ModelsListFanReferralsResponse {
  referrals?: ModelsFanReferralEntry[]
  total_count?: number
}

export interface ModelsListNewsResponse {
  news?: ModelsNews[]
  total?: number
}

export interface ModelsListNewsTagsResponse {
  /** The same tags with their labels in the request language, in the same order. */
  items?: ModelsNewsTag[]
  tags?: string[]
}

export interface ModelsListNotificationsResponse {
  notifications?: ModelsNotificationResponse[]
  total?: number
}

export interface ModelsListReferralCodesResponse {
  referral_codes?: ModelsReferralCode[]
  total?: number
}

export interface ModelsListTaskProgressResponse {
  task_progresses?: ModelsTaskProgressCard[]
  total?: number
}

export interface ModelsLocationResult {
  city?: ModelsCityFullInfo
  country?: ModelsCountryFullInfo
}

export interface ModelsLogoutRequest {
  access_token: string
  refresh_token: string
}

export interface ModelsLogoutRequestV1 {
  /** @example "<jwt_token>" */
  access_token: string
  /** @example "<refresh_token>" */
  refresh_token: string
}

export interface ModelsMarkAllAsReadResponse {
  updated_count?: number
}

export interface ModelsNews {
  /**
   * AppliedLanguage is the language the text fields were served in. Empty
   * means the untranslated original — the client labels it as such instead of
   * pretending the translation exists.
   */
  applied_language?: string
  /** AvailableLanguages lists every language this item is translated into. */
  available_languages?: string[]
  banner_subtitle?: string
  banner_title?: string
  button_color?: string
  button_text?: string
  button_url?: string
  content?: string
  created_at?: string
  cta_enabled?: boolean
  header_banner_url?: string
  header_image_url?: string
  id?: string
  is_active?: boolean
  is_liked_by_user?: boolean
  likes_count?: number
  media_blocks?: ModelsNewsMediaBlock[]
  news_date?: string
  /** Deprecated: position is replaced by tags; kept while the deployed front reads it. */
  position?: string
  reading_time_seconds?: number
  redirect_url?: string
  short_description?: string
  status?: string
  /**
   * TagLabels maps each of Tags to its label in the request language. Show
   * the label, filter by the tag.
   */
  tag_labels?: Record<string, string>
  tags?: string[]
  title?: string
  updated_at?: string
  views_count?: number
}

export interface ModelsNewsRecommendedWithNews {
  created_at?: string
  id?: string
  index_position?: number
  news?: ModelsNews
  news_id?: string
  updated_at?: string
}

export interface ModelsNewsFavoriteWithNews {
  created_at?: string
  id?: string
  news?: ModelsNews
  news_id?: string
  updated_at?: string
}

export interface ModelsNewsMainPageWithNews {
  created_at?: string
  id?: string
  index_position?: number
  news?: ModelsNews
  news_id?: string
  updated_at?: string
}

export interface ModelsNewsMediaBlock {
  items?: ModelsNewsMediaItem[]
  /** image | carousel | video */
  kind?: string
  slot?: number
}

export interface ModelsNewsMediaItem {
  cover_url?: string
  media_id?: string
  url?: string
}

export interface ModelsNewsTag {
  /** @example "Трансферы" */
  label?: string
  /** @example "Transfers" */
  tag?: string
}

export interface ModelsNotificationResponse {
  action_url?: string
  created_at?: string
  id?: string
  is_read?: boolean
  metadata?: Record<string, any>
  type?: string
}

export interface ModelsPlatformStatsResponse {
  active_clubs_count?: number
  active_fans_count?: number
  completed_challenges_count?: number
  countries_count?: number
  total_arena_points?: number
}

export enum ModelsPlayerPosition {
  Midfielder = 'Midfielder',
  Forward = 'Forward',
  Goalkeeper = 'Goalkeeper',
  Defender = 'Defender'
}

export interface ModelsPointsTaskInfo {
  brand_logo_url?: string
  brand_name?: string
  task_id?: string
  title?: string
  /** watch | share */
  type?: string
}

export interface ModelsPointsTransactionEntry {
  amount_points?: string
  atla_amount_wei?: string
  block_number?: number
  created_at?: string
  /** credit | debit */
  direction?: string
  finalized_at?: string
  id?: string
  reserve_id?: string
  source_id?: string
  source_type?: string
  /** journal rows are terminal → completed */
  status?: string
  /**
   * Task is resolved from the tasks service for source_type=task_completion;
   * absent when the source is not a task or tasks is unavailable.
   */
  task?: ModelsPointsTaskInfo
  tx_hash?: string
  /** conversion (swap_out) | accrual */
  type?: string
}

export interface ModelsPointsTransactionsResponse {
  page?: number
  page_size?: number
  total?: number
  transactions?: ModelsPointsTransactionEntry[]
}

export enum ModelsProfessionalLevel {
  ProfessionalLevelProfessional = 'PROFESSIONAL',
  ProfessionalLevelSemiProfessional = 'SEMI_PROFESSIONAL',
  ProfessionalLevelAmateur = 'AMATEUR',
  ProfessionalLevelYouth = 'YOUTH',
  ProfessionalLevelUniversity = 'UNIVERSITY'
}

export interface ModelsProgressStep {
  name?: string
  /** "pending" | "completed" */
  status?: string
}

export interface ModelsPublicSportType {
  code?: string
  icon_png_url?: string
  icon_svg_url?: string
  id?: string
  name?: string
}

export interface ModelsQuest {
  /** @example "daily_combo" */
  activity_type?: string
  /** @example 0 */
  current_count?: number
  /** @example "Login to the app" */
  description?: string
  /** @example "2024-12-31T23:59:59Z" */
  expires_at?: string
  /** @example "https://example.com/icon.png" */
  icon_url?: string
  /** @example "quest-123" */
  id?: string
  /** @example false */
  is_completed?: boolean
  /** @example "twitter" */
  platform?: string
  /** @example 1 */
  priority?: number
  /** @example 10 */
  pts_reward?: number
  /** @example "daily" */
  quest_type?: string
  /** @example 1 */
  target_count?: number
  /** @example "Daily Login" */
  title?: string
}

export interface ModelsRecoveryPasswordRequest {
  captcha_token?: string
  email: string
  /**
   * @minLength 8
   * @maxLength 30
   */
  new_password: string
  /** @min 0 */
  verification_code: number
  verification_id: string
}

export interface ModelsReferralCode {
  agent_id?: string
  code?: string
  code_type?: string
  created_at?: string
  expires_at?: string
  id?: string
  link?: string
  status?: string
  updated_at?: string
  used_at?: string
  used_by_user_id?: string
}

export interface ModelsRefreshReferralCodeRequest {
  code_type: 'AGENT' | 'CLUB'
}

export interface ModelsRefreshRequest {
  /** @example "<refresh_token>" */
  refresh_token: string
}

export interface ModelsRefreshResponse {
  access_token?: string
  refresh_token?: string
}

export interface ModelsRefreshResponseV1 {
  /** @example "<access_token>" */
  access_token?: string
  /** @example "<jwt_token>" */
  refresh_token?: string
}

export interface ModelsRegisterAgentByReferralCodeRequest {
  bio?: string
  email?: string
  password?: string
  profile_image_url?: string
  referral_code: string
  telegram?: string
  twitter?: string
  username?: string
  verification_code?: number
  verification_id?: string
}

export interface ModelsRegisterByReferralCodeRequest {
  avatar_url?: string
  banner_url?: string
  bio?: string
  /** Club name (required for clubs) */
  club_name?: string
  /** CountryCode */
  country_code?: string
  description?: string
  email?: string
  /** Favorite club ID (optional) */
  favorite_club_id?: string
  /** Favorite sport type (optional) */
  favorite_sport_type?: ModelsSportType
  password?: string
  /** Phone number for agent/club */
  phone_number?: string
  referral_code: string
  telegram_url?: string
  twitter_url?: string
  username: string
  verification_code?: number
  verification_id?: string
}

export interface ModelsRegisterByReferralCodeResponse {
  access_token: string
  entity_id?: string
  entity_type?: string
  refresh_token: string
  role?: string
  success?: boolean
  user_id?: string
}

export interface ModelsRemoveNewsLikeRequest {
  news_id: string
}

export interface ModelsRequestWithdrawalOTPResponse {
  sent?: boolean
}

export interface ModelsRerollQuestRequest {
  /**
   * @min 1
   * @example 123
   */
  quest_id: number
}

export interface ModelsRerollQuestResponse {
  /** @example "insufficient PTS" */
  error?: string
  /** @example 75 */
  next_reroll_cost?: number
  /** @example 50 */
  reroll_cost?: number
  /** @example true */
  success?: boolean
}

export interface ModelsReserveTaskResponse {
  expires_at?: string
  state?: string
  task_progress_id?: string
}

export interface ModelsReviewIssue {
  description?: string
  field_name?: string
}

export interface ModelsSaveClubApplicationDraftRequest {
  abbreviated_name?: string
  city?: string
  club_description?: string
  club_logo_url?: string
  club_name?: string
  country?: string
  facebook_url?: string
  fullname?: string
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  instagram_url?: string
  legal_documents_url?: string
  other_url?: string
  phone_number?: string
  professional_level?: string
  /** BAT-835: region (state) of the picked city */
  region?: string
  role?: string
  sport_type?: string
  tiktok_url?: string
  twitter_url?: string
  website_url?: string
  youtube_url?: string
}

export interface ModelsSaveEmailRequest {
  /** @example "example@example.com" */
  email: string
}

export interface ModelsSaveEmailResponse {
  /** @example "example@example.com" */
  email?: string
}

export interface ModelsSearchLocationsResponse {
  locations?: ModelsLocationResult[]
}

export interface ModelsSeasonResponse {
  /** @example "2024-03-31T23:59:59Z" */
  end_date?: string
  /** @example "season-2024-01" */
  id?: string
  /** @example "2024-01-01T00:00:00Z" */
  start_date?: string
  /** @example "active" */
  status?: string
}

export interface ModelsSignInPreflightRequest {
  device_fingerprint?: string
  device_id?: string
  device_platform?: string
  email: string
  /**
   * @minLength 8
   * @maxLength 30
   */
  password: string
}

export interface ModelsSignInPreflightResponse {
  /**
   * OTPRequired is false when the device is trusted and the client may sign
   * in without a code.
   */
  otp_required?: boolean
  ttl_seconds?: number
  verification_id?: string
}

export interface ModelsSignInRequest {
  captcha_token?: string
  device_fingerprint?: string
  device_id?: string
  device_platform?: string
  email: string
  /**
   * @minLength 8
   * @maxLength 30
   */
  password: string
  /** @min 0 */
  verification_code?: number
  /**
   * Verification fields are optional: a trusted-device login omits the OTP
   * and the auth service decides whether a code is required.
   */
  verification_id?: string
}

export interface ModelsSignUpRequest {
  captcha_token?: string
  /** City freeform string (optional) */
  city?: string
  /** Country freeform string (optional) */
  country?: string
  device_fingerprint?: string
  device_id?: string
  device_platform?: string
  email: string
  /** USER or CLUB */
  entity_type?: ModelsEntityType
  /** Favorite club ID (optional) */
  favorite_club_id?: string
  /** Favorite sport type (optional) */
  favorite_sport_type?: ModelsSportType
  /** Full name (optional) */
  full_name?: string
  /**
   * @minLength 8
   * @maxLength 30
   */
  password: string
  /** Fan referral code (optional) */
  referral_code?: string
  /** $!{tid} from the landing URL — conversion tracking */
  tracking_token?: string
  username?: string
  /** @min 0 */
  verification_code: number
  verification_id: string
}

export enum ModelsSortDirection {
  SortDirectionAsc = 'asc',
  SortDirectionDesc = 'desc'
}

export enum ModelsSportType {
  SportTypeFootball = 'FOOTBALL',
  SportTypeBasketball = 'BASKETBALL',
  SportTypeAmericanFootball = 'AMERICAN_FOOTBALL'
}

export interface ModelsSportTypesResponse {
  sport_types?: ModelsPublicSportType[]
}

export interface ModelsSubmitClubApplicationRequest {
  /**
   * @minLength 2
   * @maxLength 10
   */
  abbreviated_name: string
  city?: string
  /** @maxLength 2000 */
  club_description?: string
  club_logo_url?: string
  /**
   * @minLength 3
   * @maxLength 100
   */
  club_name: string
  country?: string
  facebook_url?: string
  /**
   * @minLength 2
   * @maxLength 100
   */
  fullname: string
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  instagram_url?: string
  legal_documents_url?: string
  other_url?: string
  phone_number: string
  professional_level:
    | 'PROFESSIONAL'
    | 'SEMI_PROFESSIONAL'
    | 'AMATEUR'
    | 'YOUTH'
    | 'UNIVERSITY'
  /** BAT-835: region (state) of the picked city */
  region?: string
  /** @maxLength 100 */
  role: string
  sport_type?: 'FOOTBALL'
  sport_type_id?: string
  tiktok_url?: string
  twitter_url?: string
  website_url?: string
  youtube_url?: string
}

export interface ModelsSubmitClubApplicationResponse {
  application_id?: string
  status?: string
}

export interface ModelsSubmitClubWaitlistRequest {
  /**
   * @minLength 2
   * @maxLength 255
   */
  city?: string
  /**
   * @minLength 2
   * @maxLength 255
   */
  club_name: string
  /**
   * @minLength 2
   * @maxLength 255
   */
  country?: string
  /**
   * @minLength 2
   * @maxLength 255
   */
  location?: string
  /**
   * @minLength 2
   * @maxLength 255
   */
  other_sport_name?: string
  sport_type_id?: string
  website?: string
}

export interface ModelsSubmitSocialProofRequest {
  social_proof_url: string
}

export interface ModelsSubmitTaskURLRequest {
  /** @maxLength 2048 */
  url: string
}

export interface ModelsSubmitTaskURLResponse {
  cache_hit?: boolean
  state?: string
}

export interface ModelsSupportTicket {
  club_id?: string
  created_at?: string
  id?: string
  message?: string
  status?: string
  updated_at?: string
  user_id?: string
}

export interface ModelsSwapErrorResponse {
  error?: string
}

export interface ModelsTaskActionDetails {
  action_type?: string
  brand_description?: string
  completion_condition?: string
  instruction?: string
  /** Platforms — stores this task can send the fan to; single-platform apps list one. */
  platforms?: string[]
  rules?: string
}

export interface ModelsTaskCard {
  /** ActionDetails — action-typed tasks only: full card blocks. */
  action_details?: ModelsTaskActionDetails
  available_until?: string
  brand_logo_url?: string
  brand_name?: string
  campaign_id?: string
  campaign_name?: string
  claimed_count?: number
  description?: string
  fan_reward?: number
  instruction?: object
  is_retry?: boolean
  platform?: string
  post_template?: string
  reference_video_url?: string
  state?: string
  target_views?: number
  task_id?: string
  thumbnail_url?: string
  title?: string
  type?: string
  volume?: number
}

export interface ModelsTaskProgressCard {
  /** ActionDetails — action-typed tasks only: full card blocks. */
  action_details?: ModelsTaskActionDetails
  available_until?: string
  brand_logo_url?: string
  brand_name?: string
  campaign_id?: string
  campaign_name?: string
  claimed_count?: number
  completed_at?: string
  description?: string
  /** ExpiresAt — reservation deadline; set only for state='reserved' rows. */
  expires_at?: string
  failure_message?: string
  failure_reason?: string
  fan_reward?: number
  /** FrozenUntil — raw timestamp from fan_task_freezes (may be in the past). */
  frozen_until?: string
  instruction?: object
  /** IsFrozen — true when fan has an active fan_task_freezes row for this task. */
  is_frozen?: boolean
  platform?: string
  post_template?: string
  reference_video_url?: string
  started_at?: string
  state?: string
  submitted_url?: string
  target_views?: number
  task_id?: string
  task_progress_id?: string
  thumbnail_url?: string
  title?: string
  type?: string
  views_count?: number
  /**
   * ViewsDeadlineAt — personal views-collection deadline; set only for
   * share rows currently in state='in_progress'. Lets /tasks render a
   * fan-specific countdown instead of the campaign-wide available_until.
   */
  views_deadline_at?: string
  volume?: number
}

export interface ModelsTaskStats {
  share_completed?: number
  share_pending?: number
  watch_completed?: number
}

export interface ModelsTasksLeaderboardEntry {
  avatar_url?: string
  nickname?: string
  rank?: number
  total_views?: number
  user_id?: string
}

export interface ModelsTimer {
  /** See News.AppliedLanguage / News.AvailableLanguages. */
  applied_language?: string
  available_languages?: string[]
  background_image?: string
  body?: string
  created_at?: string
  deadline?: string
  id?: string
  see_more_link?: string
  title?: string
  updated_at?: string
}

export interface ModelsTimerResponse {
  timer?: ModelsTimer
}

export enum ModelsTransactionSortField {
  TransactionSortFieldCreatedAt = 'created_at',
  TransactionSortFieldMethod = 'method',
  TransactionSortFieldBlockNumber = 'block_number'
}

export enum ModelsTransactionStatus {
  TransactionStatusConfirmed = 'confirmed',
  TransactionStatusFailed = 'failed'
}

export interface ModelsUnreadCountResponse {
  count?: number
}

export interface ModelsUpdateAgentRequest {
  avatar_url?: string
  country_code?: string
  description?: string
  phone_number?: string
  telegram_url?: string
  twitter_url?: string
}

export interface ModelsUpdateClubApplicationRequest {
  abbreviated_name?: string
  city?: string
  /** @maxLength 2000 */
  club_description?: string
  club_logo_url?: string
  club_name?: string
  country?: string
  facebook_url?: string
  /**
   * @minLength 2
   * @maxLength 100
   */
  fullname?: string
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  instagram_url?: string
  legal_documents_url?: string
  other_url?: string
  phone_number?: string
  professional_level?: ModelsProfessionalLevel
  /** BAT-835: region (state) of the picked city */
  region?: string
  /** @maxLength 100 */
  role?: string
  sport_type?: ModelsSportType
  tiktok_url?: string
  twitter_url?: string
  website_url?: string
  youtube_url?: string
}

export interface ModelsUpdateClubRequest {
  club_image_url?: string
  club_name?: string
  description?: string
  facebook_url?: string
  instagram_url?: string
  other_url?: string
  phone_number?: string
  tiktok_url?: string
  twitter_url?: string
  website_url?: string
  youtube_url?: string
}

export interface ModelsUpdatePasswordRequest {
  /**
   * @minLength 8
   * @maxLength 30
   */
  new_password: string
  /**
   * @minLength 8
   * @maxLength 30
   */
  password: string
  /** @min 0 */
  verification_code: number
  verification_id: string
}

export interface ModelsUpdateSupportTicketRequest {
  message?: string
}

export interface ModelsUpdateUserRequest {
  avatar_url?: string
  bio?: string
  birth_date?: string
  city?: string
  country?: string
  details?: string
  facebook_url?: string
  favorite_club_id?: string
  favorite_sport_type?: ModelsSportType
  full_name?: string
  gender?: 'MALE' | 'FEMALE' | 'OTHER'
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  instagram_url?: string
  other_url?: string
  phone_number?: string
  /** BAT-835: region (state) of the picked city */
  region?: string
  tiktok_url?: string
  twitter_url?: string
  username?: string
  /** OCE-634: XOR with FavoriteClubID */
  waitlist_club_id?: string
  youtube_url?: string
}

export interface ModelsUser {
  avatar_url?: string
  bio?: string
  birth_date?: string
  city?: string
  country?: string
  country_flag_url?: string
  country_name?: string
  created_at?: string
  details?: string
  email?: string
  facebook_url?: string
  favorite_club_id?: string
  favorite_sport_type?: ModelsSportType
  full_name?: string
  /** MALE | FEMALE | OTHER */
  gender?: string
  /** BAT-835: GeoNames id of the picked city */
  geoname_id?: number
  id?: string
  instagram_url?: string
  is_email_verified?: boolean
  is_wallet_connected?: boolean
  other_url?: string
  personal_hashtag?: string
  phone_number?: string
  /** BAT-835: region (state) of the picked city */
  region?: string
  roles?: string[]
  status?: string
  tiktok_url?: string
  twitter_url?: string
  updated_at?: string
  username?: string
  /** OCE-634: XOR with FavoriteClubID */
  waitlist_club_id?: string
  wallet_address?: string
  youtube_url?: string
}

export interface ModelsUserBalance {
  boostify?: string
  staking?: string
}

export interface ModelsUserFullInfoResponse {
  agent?: ModelsAgent
  /**
   * ArenaPointsAvailable is the spendable balance: SUM(journal) − active
   * reserves. Diverges from lifetime once the ATLA↔AP converter spends
   * points (negative swap_out rows). Null when economy was unavailable.
   */
  arena_points_available?: number
  arena_points_lifetime?: number
  challenges_completed?: number
  favorite_club?: ModelsFavoriteClub
  global_rank?: number
  global_rank_change_daily?: number
  pts_balance?: number
  pts_lifetime?: number
  referrals_count?: number
  roles?: string[]
  task_stats?: ModelsTaskStats
  tasks_success_count?: number
  /**
   * Fans-leaderboard-sourced stats for the /tasks stats cards (OCE-1183).
   * These come from the leaderboards service + economy, not the legacy
   * quest path. GlobalRankChangeDaily is unset when no daily snapshot yet.
   */
  total_views?: number
  user?: ModelsUser
  /** OCE-634: XOR with FavoriteClub */
  waitlist_club?: ModelsWaitlistClub
}

export interface ModelsValidateAccessTokenRequest {
  access_token: string
}

export interface ModelsValidateAccessTokenResponse {
  agent_id?: string
  club_id?: string
  club_name?: string
  error_message?: string
  roles?: string[]
  user?: ModelsUser
  valid?: boolean
}

export interface ModelsValidateReferralCodeRequest {
  referral_code: string
}

export interface ModelsValidateReferralCodeResponse {
  /** REFERRAL_CODE_AGENT, REFERRAL_CODE_CLUB */
  code_type?: string
  /** USER_ROLE_AGENT, USER_ROLE_CLUB */
  role?: string
  valid?: boolean
}

export interface ModelsVerifyCodeRequest {
  action_type: ModelsActionType
  email: string
  /** @min 0 */
  verification_code: number
  verification_id: string
}

export interface ModelsVerifyCodeResponse {
  is_valid?: boolean
}

export interface ModelsVerifySignatureResponse {
  access_token?: string
  entity_id?: string
  entity_type?: string
  /**
   * ReferralType — sign-up only: whose referral code was used (fan, club,
   * athlete, agent); for GA4. Absent without a code.
   */
  referral_type?: string
  refresh_token?: string
  /** Account status (ACTIVE, PENDING_ADMIN_APPROVE, VERIFIED, etc.) */
  status?: ModelsAccountStatus
  user?: ModelsUser
  username?: string
}

export interface ModelsVerifyWithdrawalOTPRequest {
  otp: number
}

export interface ModelsVerifyWithdrawalOTPResponse {
  confirmation_token?: string
  valid?: boolean
}

export interface ModelsWaitlistClub {
  club_name?: string
  fan_count?: number
  id?: string
  location?: string
  website?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '/'
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(
      typeof value === 'number' ? value : `${value}`
    )}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      key => 'undefined' !== typeof query[key]
    )
    return keys
      .map(key =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${
        queryString ? `?${queryString}` : ''
      }`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {})
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body)
      }
    ).then(async response => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then(data => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch(e => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data.data
    })
  }
}

/**
 * @title API
 * @version 2.0
 * @license Apache 2.0 (http://www.apache.org/licenses/LICENSE-2.0.html)
 * @termsOfService http://swagger.io/terms/
 * @baseUrl /
 * @contact
 *
 * This is an auto-generated API Docs.
 */
export class MarketApi<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {

    /**
     * @description Invalidate refresh token
     *
     * @tags Authentication
     * @name V1AuthLogoutCreate
     * @summary Logout user
     * @request POST:/api/v1/auth/logout
     * @deprecated
     * @secure
     */
    v1AuthLogoutCreate: (
      request: ModelsLogoutRequestV1,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v1/auth/logout`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Get new access token using refresh token
     *
     * @tags Authentication
     * @name V1AuthRefreshCreate
     * @summary Refresh access token
     * @request POST:/api/v1/auth/refresh
     * @deprecated
     */
    v1AuthRefreshCreate: (
      request: ModelsRefreshRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsRefreshResponseV1, any>({
        path: `/api/v1/auth/refresh`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Save user's email for receiving notifications
     *
     * @tags Notifier
     * @name V1NotifierEmailCreate
     * @summary Save email for notifications
     * @request POST:/api/v1/notifier/email
     * @deprecated
     */
    v1NotifierEmailCreate: (
      request: ModelsSaveEmailRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSaveEmailResponse, any>({
        path: `/api/v1/notifier/email`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get agent details by ID
     *
     * @tags Agents V2
     * @name V2AgentsDetail
     * @summary Get agent by ID (V2)
     * @request GET:/api/v2/agents/{id}
     * @deprecated
     */
    v2AgentsDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsAgentResponse, any>({
        path: `/api/v2/agents/${id}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description List agents with full user information
     *
     * @tags Agents V2
     * @name V2AgentsFullInfoList
     * @summary List agents with full info (V2)
     * @request GET:/api/v2/agents/full-info
     * @deprecated
     */
    v2AgentsFullInfoList: (
      query?: {
        /** Invited by agent ID */
        invited_by_agent_id?: string
        /** Limit */
        limit?: number
        /** Offset */
        offset?: number
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListAgentsResponse, any>({
        path: `/api/v2/agents/full-info`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description List agents with pagination and filtering
     *
     * @tags Agents V2
     * @name V2AgentsList
     * @summary List agents (V2)
     * @request GET:/api/v2/agents
     * @deprecated
     */
    v2AgentsList: (
      query?: {
        /** Invited by agent ID */
        invited_by_agent_id?: string
        /** Limit */
        limit?: number
        /** Offset */
        offset?: number
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListAgentsResponse, any>({
        path: `/api/v2/agents`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns club-activation payouts owed to the current agent (OCE-294)
     *
     * @tags Agents V2
     * @name V2AgentsMePayoutsList
     * @summary Get current agent payouts (V2)
     * @request GET:/api/v2/agents/me/payouts
     * @deprecated
     * @secure
     */
    v2AgentsMePayoutsList: (
      query?: {
        /** Page (default 1) */
        page?: number
        /** Page size (default 20) */
        page_size?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsAgentPayoutsResponse, any>({
        path: `/api/v2/agents/me/payouts`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get aggregated agent profile with referral codes, recruited clubs/agents, and earnings
     *
     * @tags Agents V2
     * @name V2AgentsMeProfileList
     * @summary Get agent profile (aggregated)
     * @request GET:/api/v2/agents/me/profile
     * @secure
     */
    v2AgentsMeProfileList: (params: RequestParams = {}) =>
      this.request<ModelsAgentProfileResponse, ModelsCompleteActivityRequest>({
        path: `/api/v2/agents/me/profile`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get all referral codes for the current agent from JWT token
     *
     * @tags Agents V2
     * @name V2AgentsMeReferralCodesList
     * @summary Get current agent referral codes (V2)
     * @request GET:/api/v2/agents/me/referral-codes
     * @deprecated
     * @secure
     */
    v2AgentsMeReferralCodesList: (
      query?: {
        /** Code type filter (AGENT, CLUB) */
        code_type?: string
        /** Status filter (ACTIVE, USED, EXPIRED) */
        status?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListReferralCodesResponse, any>({
        path: `/api/v2/agents/me/referral-codes`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Deactivate existing referral code of given type and generate a new one
     *
     * @tags Agents V2
     * @name V2AgentsMeReferralCodesRefreshCreate
     * @summary Refresh agent referral code
     * @request POST:/api/v2/agents/me/referral-codes/refresh
     * @deprecated
     * @secure
     */
    v2AgentsMeReferralCodesRefreshCreate: (
      request: ModelsRefreshReferralCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsReferralCode, ModelsCompleteActivityRequest>({
        path: `/api/v2/agents/me/referral-codes/refresh`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get all users referred by the current agent from JWT token
     *
     * @tags Agents V2
     * @name V2AgentsMeReferralsList
     * @summary Get current agent referrals (V2)
     * @request GET:/api/v2/agents/me/referrals
     * @secure
     */
    v2AgentsMeReferralsList: (
      query?: {
        /** Limit */
        limit?: number
        /** Offset */
        offset?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsGetAgentReferralsResponse, any>({
        path: `/api/v2/agents/me/referrals`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Update current agent details from JWT token
     *
     * @tags Agents V2
     * @name V2AgentsMeUpdate
     * @summary Update current agent (V2)
     * @request PUT:/api/v2/agents/me
     * @secure
     */
    v2AgentsMeUpdate: (
      request: ModelsUpdateAgentRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsAgentResponse, any>({
        path: `/api/v2/agents/me`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Register a new agent using a referral code
     *
     * @tags Agents V2
     * @name V2AgentsRegisterByReferralCodeCreate
     * @summary Register agent by referral code (V2)
     * @request POST:/api/v2/agents/register-by-referral-code
     * @deprecated
     */
    v2AgentsRegisterByReferralCodeCreate: (
      request: ModelsRegisterAgentByReferralCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsRegisterByReferralCodeResponse, any>({
        path: `/api/v2/agents/register-by-referral-code`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Attach an email address to an existing user account
     *
     * @tags Authentication V2
     * @name V2AuthAttachEmailCreate
     * @summary Attach email to user (V2)
     * @request POST:/api/v2/auth/attach-email
     * @deprecated
     */
    v2AuthAttachEmailCreate: (
      request: ModelsAttachUserEmailRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v2/auth/attach-email`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Check if a user with the given email already exists
     *
     * @tags Authentication V2
     * @name V2AuthCheckUserExistsByEmailList
     * @summary Check if user exists by email (V2)
     * @request GET:/api/v2/auth/check-user-exists-by-email
     */
    v2AuthCheckUserExistsByEmailList: (
      query: {
        /** Email address */
        email: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsCheckUserExistsByEmailResponse, any>({
        path: `/api/v2/auth/check-user-exists-by-email`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Check if a user with the given username already exists
     *
     * @tags Authentication V2
     * @name V2AuthCheckUserExistsByUsernameList
     * @summary Check if user exists by username (V2)
     * @request GET:/api/v2/auth/check-user-exists-by-username
     * @deprecated
     */
    v2AuthCheckUserExistsByUsernameList: (
      query: {
        /** Username */
        username: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsCheckUserExistsByUsernameResponse, any>({
        path: `/api/v2/auth/check-user-exists-by-username`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get the current club application status and details. Club ID is obtained from JWT token.
     *
     * @tags Club Authentication V2
     * @name V2AuthClubsApplicationList
     * @summary Get club application status (V2)
     * @request GET:/api/v2/auth/clubs/application
     * @secure
     */
    v2AuthClubsApplicationList: (params: RequestParams = {}) =>
      this.request<ModelsClubApplication, any>({
        path: `/api/v2/auth/clubs/application`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Update an existing club application with new information. Club ID is obtained from JWT token.
     *
     * @tags Club Authentication V2
     * @name V2AuthClubsApplicationUpdate
     * @summary Update club verification application (V2)
     * @request PUT:/api/v2/auth/clubs/application/{application_id}
     * @secure
     */
    v2AuthClubsApplicationUpdate: (
      applicationId: string,
      request: ModelsUpdateClubApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsClubApplication, any>({
        path: `/api/v2/auth/clubs/application/${applicationId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieve the saved club application draft
     *
     * @tags Auth V2
     * @name V2AuthClubsDraftList
     * @summary Get club application draft
     * @request GET:/api/v2/auth/clubs/draft
     * @secure
     */
    v2AuthClubsDraftList: (params: RequestParams = {}) =>
      this.request<
        ModelsClubApplicationDraftResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/auth/clubs/draft`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Save or update a club application draft. All fields are optional.
     *
     * @tags Auth V2
     * @name V2AuthClubsDraftUpdate
     * @summary Save club application draft
     * @request PUT:/api/v2/auth/clubs/draft
     * @secure
     */
    v2AuthClubsDraftUpdate: (
      request: ModelsSaveClubApplicationDraftRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ModelsClubApplicationDraftResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/auth/clubs/draft`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Submit a club application for verification with detailed club information. Club ID is obtained from JWT token.
     *
     * @tags Club Authentication V2
     * @name V2AuthClubsSubmitApplicationCreate
     * @summary Submit club verification application (V2)
     * @request POST:/api/v2/auth/clubs/submit-application
     * @secure
     */
    v2AuthClubsSubmitApplicationCreate: (
      request: ModelsSubmitClubApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSubmitClubApplicationResponse, any>({
        path: `/api/v2/auth/clubs/submit-application`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Send verification code to email for various actions (SIGN_UP, LOG_IN, RECOVERY_PASSWORD, UPDATE_EMAIL, DELETE_ACCOUNT, UPDATE_PASSWORD)
     *
     * @tags Authentication V2
     * @name V2AuthEmailVerificationCreate
     * @summary Send email verification code (V2)
     * @request POST:/api/v2/auth/email-verification
     */
    v2AuthEmailVerificationCreate: (
      request: ModelsEmailVerificationRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsEmailVerificationResponse, any>({
        path: `/api/v2/auth/email-verification`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Exchange Google OAuth code for JWT tokens. When entity_type is omitted and deferred signup is enabled (OCE-546), returns requires_role_selection=true + google_signup_token for the frontend to finalise via /google/complete-signup.
     *
     * @tags Authentication V2
     * @name V2AuthGoogleCallbackCreate
     * @summary Handle Google OAuth callback (V2)
     * @request POST:/api/v2/auth/google/callback
     */
    v2AuthGoogleCallbackCreate: (
      request: ModelsHandleGoogleCallbackRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsHandleGoogleCallbackResponseV2, any>({
        path: `/api/v2/auth/google/callback`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Finalises signup started by /google/callback when requires_role_selection was returned. Accepts the short-lived google_signup_token and the role picked by the user (OCE-546).
     *
     * @tags Authentication V2
     * @name V2AuthGoogleCompleteSignupCreate
     * @summary Complete deferred Google OAuth signup (V2)
     * @request POST:/api/v2/auth/google/complete-signup
     */
    v2AuthGoogleCompleteSignupCreate: (
      request: ModelsCompleteGoogleSignupRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsVerifySignatureResponse, any>({
        path: `/api/v2/auth/google/complete-signup`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get Google OAuth consent URL for sign-in/sign-up
     *
     * @tags Authentication V2
     * @name V2AuthGoogleList
     * @summary Init Google OAuth flow (V2)
     * @request GET:/api/v2/auth/google
     */
    v2AuthGoogleList: (
      query?: {
        /** Custom redirect URI */
        redirect_uri?: string
        /** Referral code (OCE-555) */
        referral_code?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsInitGoogleOAuthResponse, any>({
        path: `/api/v2/auth/google`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Invalidate refresh token
     *
     * @tags Authentication V2
     * @name V2AuthLogoutCreate
     * @summary Logout user (V2)
     * @request POST:/api/v2/auth/logout
     * @secure
     */
    v2AuthLogoutCreate: (
      request: ModelsLogoutRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v2/auth/logout`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Reset user password with verification code
     *
     * @tags Authentication V2
     * @name V2AuthRecoveryPasswordCreate
     * @summary Recover password (V2)
     * @request POST:/api/v2/auth/recovery-password
     */
    v2AuthRecoveryPasswordCreate: (
      request: ModelsRecoveryPasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v2/auth/recovery-password`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Get new access token using refresh token
     *
     * @tags Authentication V2
     * @name V2AuthRefreshCreate
     * @summary Refresh access token (V2)
     * @request POST:/api/v2/auth/refresh
     */
    v2AuthRefreshCreate: (
      request: ModelsRefreshRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsRefreshResponse, any>({
        path: `/api/v2/auth/refresh`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Authenticate user with email and password
     *
     * @tags Authentication V2
     * @name V2AuthSigninCreate
     * @summary Sign in with email and password (V2)
     * @request POST:/api/v2/auth/signin
     */
    v2AuthSigninCreate: (
      request: ModelsSignInRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsVerifySignatureResponse, any>({
        path: `/api/v2/auth/signin`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Временный роут OCE-816: проверяет email+password до отправки OTP. Любая неудача credentials — AU-205 (generic invalid credentials). Будет superseded OCE-663 (challenge-token flow).
     *
     * @tags Authentication V2
     * @name V2AuthSigninPreflightCreate
     * @summary SignInPreflight — временный роут OCE-816 (по требованию продукта)
     * @request POST:/api/v2/auth/signin/preflight
     */
    v2AuthSigninPreflightCreate: (
      request: ModelsSignInPreflightRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSignInPreflightResponse, any>({
        path: `/api/v2/auth/signin/preflight`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Create a new user or club account with email and password. Supports registration as either a regular user or a club by specifying entity_type.
     *
     * @tags Authentication V2
     * @name V2AuthSignupCreate
     * @summary Sign up with email and password (V2)
     * @request POST:/api/v2/auth/signup
     */
    v2AuthSignupCreate: (
      request: ModelsSignUpRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsVerifySignatureResponse, any>({
        path: `/api/v2/auth/signup`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Update user password with current password and verification code
     *
     * @tags Authentication V2
     * @name V2AuthUpdatePasswordCreate
     * @summary Update password (V2)
     * @request POST:/api/v2/auth/update-password
     * @deprecated
     * @secure
     */
    v2AuthUpdatePasswordCreate: (
      request: ModelsUpdatePasswordRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v2/auth/update-password`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Validate access token and return user info
     *
     * @tags Authentication V2
     * @name V2AuthValidateCreate
     * @summary Validate access token (V2)
     * @request POST:/api/v2/auth/validate
     * @deprecated
     */
    v2AuthValidateCreate: (
      request: ModelsValidateAccessTokenRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsValidateAccessTokenResponse, any>({
        path: `/api/v2/auth/validate`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Check if referral code is valid and get its type and role
     *
     * @tags Authentication V2
     * @name V2AuthValidateReferralCodeCreate
     * @summary Validate referral code (V2)
     * @request POST:/api/v2/auth/validate-referral-code
     * @deprecated
     */
    v2AuthValidateReferralCodeCreate: (
      request: ModelsValidateReferralCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsValidateReferralCodeResponse, any>({
        path: `/api/v2/auth/validate-referral-code`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Validate the verification code sent to email
     *
     * @tags Authentication V2
     * @name V2AuthVerifyCodeCreate
     * @summary Verify email verification code (V2)
     * @request POST:/api/v2/auth/verify-code
     */
    v2AuthVerifyCodeCreate: (
      request: ModelsVerifyCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsVerifyCodeResponse, any>({
        path: `/api/v2/auth/verify-code`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Send OTP code to user's email for withdrawal 2FA verification
     *
     * @tags Authentication V2
     * @name V2AuthWithdrawalOtpCreate
     * @summary Request OTP for withdrawal (V2)
     * @request POST:/api/v2/auth/withdrawal/otp
     * @deprecated
     * @secure
     */
    v2AuthWithdrawalOtpCreate: (params: RequestParams = {}) =>
      this.request<ModelsRequestWithdrawalOTPResponse, any>({
        path: `/api/v2/auth/withdrawal/otp`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Verify OTP code and get confirmation token for withdrawal
     *
     * @tags Authentication V2
     * @name V2AuthWithdrawalVerifyCreate
     * @summary Verify withdrawal OTP (V2)
     * @request POST:/api/v2/auth/withdrawal/verify
     * @deprecated
     * @secure
     */
    v2AuthWithdrawalVerifyCreate: (
      request: ModelsVerifyWithdrawalOTPRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsVerifyWithdrawalOTPResponse, any>({
        path: `/api/v2/auth/withdrawal/verify`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description List clubs invited by a specific agent
     *
     * @tags Entries V2
     * @name V2ClubsByAgentDetail
     * @summary List clubs by agent (V2)
     * @request GET:/api/v2/clubs/by-agent/{agent_id}
     * @deprecated
     */
    v2ClubsByAgentDetail: (
      agentId: string,
      query?: {
        /** Limit */
        limit?: number
        /** Offset */
        offset?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListClubsResponse, any>({
        path: `/api/v2/clubs/by-agent/${agentId}`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get club details by ID
     *
     * @tags Entries V2
     * @name V2ClubsDetail
     * @summary Get club by ID (V2)
     * @request GET:/api/v2/clubs/{id}
     */
    v2ClubsDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsClubResponse, any>({
        path: `/api/v2/clubs/${id}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Public list of Active clubs for the «Partner Clubs» marquee on the home page and /clubs. ap_score is reserved at 0 until the AP formula is finalised (OCE-871).
     *
     * @tags Entries V2
     * @name V2ClubsFeaturedList
     * @summary Get featured clubs for marquee block (V2)
     * @request GET:/api/v2/clubs/featured
     */
    v2ClubsFeaturedList: (
      query?: {
        /** Number of clubs to return (1..50, default 12) */
        limit?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsGetFeaturedClubsResponse, any>({
        path: `/api/v2/clubs/featured`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description List clubs with full user information. Defaults to VERIFIED clubs only.
     *
     * @tags Entries V2
     * @name V2ClubsFullInfoList
     * @summary List clubs with full info (V2)
     * @request GET:/api/v2/clubs/full-info
     */
    v2ClubsFullInfoList: (
      query?: {
        /** Invited by agent ID */
        invited_by_agent_id?: string
        /** Limit */
        limit?: number
        /** Offset */
        offset?: number
        /** Search */
        search?: string
        /** Sport filter: FOOTBALL, BASKETBALL, AMERICAN_FOOTBALL, CRICKET, ESPORTS, BOXING_MMA, RUGBY, OTHER */
        sport_type?: string
        /** Club status filter (VERIFIED, ACTIVE). Defaults to VERIFIED. */
        status?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListClubsResponse, any>({
        path: `/api/v2/clubs/full-info`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description List clubs with pagination and filtering. Defaults to VERIFIED clubs only.
     *
     * @tags Entries V2
     * @name V2ClubsList
     * @summary List clubs (V2)
     * @request GET:/api/v2/clubs
     */
    v2ClubsList: (
      query?: {
        /** Invited by agent ID */
        invited_by_agent_id?: string
        /** Limit */
        limit?: number
        /** Offset */
        offset?: number
        /** Search */
        search?: string
        /** Sport filter: FOOTBALL, BASKETBALL, AMERICAN_FOOTBALL, CRICKET, ESPORTS, BOXING_MMA, RUGBY, OTHER */
        sport_type?: string
        /** Club status filter (VERIFIED, ACTIVE). Defaults to VERIFIED. */
        status?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListClubsResponse, any>({
        path: `/api/v2/clubs`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Generate a presigned URL for uploading a club file (documents, etc.)
     *
     * @tags Entries V2
     * @name V2ClubsMeGenerateFileUploadUrlCreate
     * @summary Generate club file upload URL
     * @request POST:/api/v2/clubs/me/generate-file-upload-url
     * @secure
     */
    v2ClubsMeGenerateFileUploadUrlCreate: (
      request: ModelsGenerateClubFileUploadURLRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsGenerateImageUploadURLResponse, any>({
        path: `/api/v2/clubs/me/generate-file-upload-url`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get current club details from JWT token
     *
     * @tags Entries V2
     * @name V2ClubsMeList
     * @summary Get current club (V2)
     * @request GET:/api/v2/clubs/me
     * @secure
     */
    v2ClubsMeList: (params: RequestParams = {}) =>
      this.request<ModelsClubResponse, any>({
        path: `/api/v2/clubs/me`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Submit social proof URL for club activation
     *
     * @tags Clubs V2
     * @name V2ClubsMeSocialProofCreate
     * @summary Submit social proof
     * @request POST:/api/v2/clubs/me/social-proof
     * @secure
     */
    v2ClubsMeSocialProofCreate: (
      request: ModelsSubmitSocialProofRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ModelsCompleteActivityRequest>({
        path: `/api/v2/clubs/me/social-proof`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Update current club information from JWT token with club image and banner URLs
     *
     * @tags Entries V2
     * @name V2ClubsMeUpdate
     * @summary Update current club (V2)
     * @request PUT:/api/v2/clubs/me
     * @secure
     */
    v2ClubsMeUpdate: (
      request: ModelsUpdateClubRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v2/clubs/me`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Get public club profile by ID
     *
     * @tags Clubs V2
     * @name V2ClubsProfileDetail
     * @summary Get club profile (public)
     * @request GET:/api/v2/clubs/{id}/profile
     */
    v2ClubsProfileDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsClubProfileResponse, ModelsCompleteActivityRequest>({
        path: `/api/v2/clubs/${id}/profile`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get club profile with owner-specific data (activation progress)
     *
     * @tags Clubs V2
     * @name V2ClubsProfileMeDetail
     * @summary Get club profile (authenticated)
     * @request GET:/api/v2/clubs/{id}/profile/me
     * @secure
     */
    v2ClubsProfileMeDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsClubProfileResponse, ModelsCompleteActivityRequest>({
        path: `/api/v2/clubs/${id}/profile/me`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Owner-enriched profile of the club that belongs to the currently authenticated user. Resolves club by JWT user_id, so no path :id is needed. Returns activation_progress together with the club record.
     *
     * @tags Clubs V2
     * @name V2ClubsProfileMeList
     * @summary Get current user's own club profile (authenticated, OCE-653)
     * @request GET:/api/v2/clubs/profile/me
     * @secure
     */
    v2ClubsProfileMeList: (params: RequestParams = {}) =>
      this.request<ModelsClubProfileResponse, ModelsCompleteActivityRequest>({
        path: `/api/v2/clubs/profile/me`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Create a new support ticket. User ID is obtained from JWT token.
     *
     * @tags Club Support Tickets V2
     * @name V2ClubsSupportTicketsCreate
     * @summary Create a support ticket (V2)
     * @request POST:/api/v2/clubs/support-tickets
     * @secure
     */
    v2ClubsSupportTicketsCreate: (
      request: ModelsCreateSupportTicketRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSupportTicket, any>({
        path: `/api/v2/clubs/support-tickets`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieve a support ticket by its ID.
     *
     * @tags Club Support Tickets V2
     * @name V2ClubsSupportTicketsDetail
     * @summary Get support ticket by ID (V2)
     * @request GET:/api/v2/clubs/support-tickets/{ticket_id}
     * @secure
     */
    v2ClubsSupportTicketsDetail: (
      ticketId: string,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSupportTicket, any>({
        path: `/api/v2/clubs/support-tickets/${ticketId}`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieve a support ticket by user ID. User ID is obtained from JWT token.
     *
     * @tags Club Support Tickets V2
     * @name V2ClubsSupportTicketsMeList
     * @summary Get user's support ticket (V2)
     * @request GET:/api/v2/clubs/support-tickets/me
     * @secure
     */
    v2ClubsSupportTicketsMeList: (params: RequestParams = {}) =>
      this.request<ModelsSupportTicket, any>({
        path: `/api/v2/clubs/support-tickets/me`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Update a support ticket message.
     *
     * @tags Club Support Tickets V2
     * @name V2ClubsSupportTicketsUpdate
     * @summary Update support ticket (V2)
     * @request PUT:/api/v2/clubs/support-tickets/{ticket_id}
     * @secure
     */
    v2ClubsSupportTicketsUpdate: (
      ticketId: string,
      request: ModelsUpdateSupportTicketRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSupportTicket, any>({
        path: `/api/v2/clubs/support-tickets/${ticketId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Adds a "virtual" club to the waitlist registry. Deduped by normalized (name, location). Returns the record id — caller typically passes it to PUT /users/me as waitlist_club_id.
     *
     * @tags Clubs V2
     * @name V2ClubsWaitlistCreate
     * @summary Submit a club to the waitlist (OCE-634)
     * @request POST:/api/v2/clubs/waitlist
     * @secure
     */
    v2ClubsWaitlistCreate: (
      request: ModelsSubmitClubWaitlistRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ModelsClubWaitlistRequestResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/clubs/waitlist`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of all supported countries. Supports full-text search by country name in English and the specified language.
     *
     * @tags Countries
     * @name V2CountriesList
     * @summary Get supported countries
     * @request GET:/api/v2/countries
     */
    v2CountriesList: (
      query?: {
        /** Search query for country names (searches in English and the specified language) */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsCountryResponse, any>({
        path: `/api/v2/countries`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Re-publish multiple dead-letter queue messages to their original topics
     *
     * @tags DLQ V2
     * @name V2DlqMessagesBatchReplayCreate
     * @summary Replay a batch of DLQ messages (V2)
     * @request POST:/api/v2/dlq/messages/batch/replay
     * @secure
     */
    v2DlqMessagesBatchReplayCreate: (
      body: ModelsDLQBatchRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsDLQBatchResponse, any>({
        path: `/api/v2/dlq/messages/batch/replay`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get a single dead-letter queue message by its ID
     *
     * @tags DLQ V2
     * @name V2DlqMessagesDetail
     * @summary Get DLQ message by ID (V2)
     * @request GET:/api/v2/dlq/messages/{id}
     * @secure
     */
    v2DlqMessagesDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsDLQMessage, any>({
        path: `/api/v2/dlq/messages/${id}`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Mark a dead-letter queue message as discarded (will not be retried)
     *
     * @tags DLQ V2
     * @name V2DlqMessagesDiscardCreate
     * @summary Discard a single DLQ message (V2)
     * @request POST:/api/v2/dlq/messages/{id}/discard
     * @secure
     */
    v2DlqMessagesDiscardCreate: (
      id: string,
      body: object,
      params: RequestParams = {}
    ) =>
      this.request<ModelsDLQMessage, any>({
        path: `/api/v2/dlq/messages/${id}/discard`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description List dead-letter queue messages with optional filtering and pagination
     *
     * @tags DLQ V2
     * @name V2DlqMessagesList
     * @summary List DLQ messages (V2)
     * @request GET:/api/v2/dlq/messages
     * @secure
     */
    v2DlqMessagesList: (
      query?: {
        /** Error class (permanent, unknown) */
        error_class?: string
        /** Substring match on error message */
        error_message_contains?: string
        /** Number of items per page (default 50) */
        page_size?: number
        /** Opaque pagination token */
        page_token?: string
        /** RFC3339 lower bound for received_at */
        received_after?: string
        /** RFC3339 upper bound for received_at */
        received_before?: string
        /** Source service name */
        source_service?: string
        /** Source Kafka topic */
        source_topic?: string
        /** Message status (pending, replayed, discarded) */
        status?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsDLQListResponse, any>({
        path: `/api/v2/dlq/messages`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Re-publish a dead-letter queue message to its original topic
     *
     * @tags DLQ V2
     * @name V2DlqMessagesReplayCreate
     * @summary Replay a single DLQ message (V2)
     * @request POST:/api/v2/dlq/messages/{id}/replay
     * @secure
     */
    v2DlqMessagesReplayCreate: (
      id: string,
      body: object,
      params: RequestParams = {}
    ) =>
      this.request<ModelsDLQMessage, any>({
        path: `/api/v2/dlq/messages/${id}/replay`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get aggregate statistics for the dead-letter queue, optionally filtered by source service
     *
     * @tags DLQ V2
     * @name V2DlqStatsList
     * @summary Get DLQ statistics (V2)
     * @request GET:/api/v2/dlq/stats
     * @secure
     */
    v2DlqStatsList: (
      query?: {
        /** Filter stats by source service */
        source_service?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsDLQStats, any>({
        path: `/api/v2/dlq/stats`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags External Services V2
     * @name V2ExternalServicesConnectCreate
     * @summary Connect an external service (Swap) by one-time code
     * @request POST:/api/v2/external-services/connect
     * @secure
     */
    v2ExternalServicesConnectCreate: (
      request: ModelsConnectExternalServiceRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsConnectedServiceEntry, ModelsSwapErrorResponse>({
        path: `/api/v2/external-services/connect`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags External Services V2
     * @name V2ExternalServicesConnectedList
     * @summary List connected external services
     * @request GET:/api/v2/external-services/connected
     * @secure
     */
    v2ExternalServicesConnectedList: (params: RequestParams = {}) =>
      this.request<ModelsConnectedServicesResponse, any>({
        path: `/api/v2/external-services/connected`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags External Services V2
     * @name V2ExternalServicesDelete
     * @summary Disconnect an external service
     * @request DELETE:/api/v2/external-services/{service}
     * @secure
     */
    v2ExternalServicesDelete: (service: string, params: RequestParams = {}) =>
      this.request<
        ModelsDisconnectExternalServiceResponse,
        ModelsSwapErrorResponse
      >({
        path: `/api/v2/external-services/${service}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns one page of the Clubs Leaderboard. Optional sport_type scopes to a single sport; omit it for All Sports. Optional search filters by club name (clubs- service trigram). Backed by Redis cache, TTL 60s.
     *
     * @tags Leaderboards V2
     * @name V2LeaderboardsClubsList
     * @summary Get Clubs Leaderboard (per-sport or All Sports)
     * @request GET:/api/v2/leaderboards/clubs
     */
    v2LeaderboardsClubsList: (
      query?: {
        /**
         * Zero-based page
         * @min 0
         * @max 10000
         * @default 0
         */
        page?: number
        /**
         * Page size
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number
        /** world (default) or my_country; my_country falls back to world for viewers without a resolvable country */
        region?: string
        /** Filter clubs by name */
        search?: string
        /** Dictionary sport code; omit for All Sports */
        sport_type?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ModelsClubsLeaderboardResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/leaderboards/clubs`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns one page of the Fans Leaderboard. Pass club_id to scope to a single club; omit it for the global aggregation.
     *
     * @tags Leaderboards V2
     * @name V2LeaderboardsFansList
     * @summary Get Fans Leaderboard (club-scoped or global)
     * @request GET:/api/v2/leaderboards/fans
     */
    v2LeaderboardsFansList: (
      query?: {
        /** Club UUID; omit for global leaderboard */
        club_id?: string
        /**
         * Zero-based page
         * @min 0
         * @max 10000
         * @default 0
         */
        page?: number
        /**
         * Page size
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number
        /** world (default) or my_country; my_country falls back to world for viewers without a resolvable country */
        region?: string
        /** Dictionary sport code; omit for All Sports */
        sport_type?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ModelsFansLeaderboardResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/leaderboards/fans`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns the authenticated fan's rank in the requested scope. Omit club_id and sport_type for the global All Sports rank.
     *
     * @tags Leaderboards V2
     * @name V2LeaderboardsFansPositionList
     * @summary Get Fans Leaderboard position (club-scoped, sport-scoped, or global)
     * @request GET:/api/v2/leaderboards/fans/position
     * @secure
     */
    v2LeaderboardsFansPositionList: (
      query?: {
        /** Club UUID; omit for global leaderboard */
        club_id?: string
        /** Dictionary sport code; omit for All Sports */
        sport_type?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ModelsFansLeaderboardPositionResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/leaderboards/fans/position`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get detailed information about a city by its ID
     *
     * @tags Locations
     * @name V2LocationsCitiesDetail
     * @summary Get city by ID
     * @request GET:/api/v2/locations/cities/{id}
     * @deprecated
     */
    v2LocationsCitiesDetail: (id: number, params: RequestParams = {}) =>
      this.request<ModelsCityFullInfo, any>({
        path: `/api/v2/locations/cities/${id}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get detailed information about a country by its ID
     *
     * @tags Locations
     * @name V2LocationsCountriesDetail
     * @summary Get country by ID
     * @request GET:/api/v2/locations/countries/{id}
     * @deprecated
     */
    v2LocationsCountriesDetail: (id: number, params: RequestParams = {}) =>
      this.request<ModelsCountryFullInfo, any>({
        path: `/api/v2/locations/countries/${id}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Search for countries and cities by query string
     *
     * @tags Locations
     * @name V2LocationsSearchList
     * @summary Search locations (countries and cities)
     * @request GET:/api/v2/locations/search
     */
    v2LocationsSearchList: (
      query: {
        /** Limit (default: 10) */
        limit?: number
        /** Offset (default: 0) */
        offset?: number
        /** Search query */
        query: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsSearchLocationsResponse, any>({
        path: `/api/v2/locations/search`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get all recommended news items with news details
     *
     * @tags News V2
     * @name V2NewsRecommendedList
     * @summary Get all recommended news items (V2)
     * @request GET:/api/v2/news/recommended
     */
    v2NewsRecommendedList: (params: RequestParams = {}) =>
      this.request<ModelsGetAllNewsRecommendedResponse, any>({
        path: `/api/v2/news/recommended`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get news details by ID
     *
     * @tags News V2
     * @name V2NewsDetail
     * @summary Get news by ID (V2)
     * @request GET:/api/v2/news/{id}
     */
    v2NewsDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsGetNewsByIDResponse, any>({
        path: `/api/v2/news/${id}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get the favorite news item with news details
     *
     * @tags News V2
     * @name V2NewsFavoriteList
     * @summary Get news favorite (V2)
     * @request GET:/api/v2/news/favorite
     */
    v2NewsFavoriteList: (params: RequestParams = {}) =>
      this.request<ModelsGetNewsFavoriteResponse, any>({
        path: `/api/v2/news/favorite`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Add like to news by user
     *
     * @tags News V2
     * @name V2NewsLikesCreate
     * @summary Add like to news (V2)
     * @request POST:/api/v2/news/likes
     * @secure
     */
    v2NewsLikesCreate: (
      request: ModelsAddNewsLikeRequest,
      params: RequestParams = {}
    ) =>
      this.request<Record<string, string>, any>({
        path: `/api/v2/news/likes`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Remove like from news by user
     *
     * @tags News V2
     * @name V2NewsLikesDelete
     * @summary Remove like from news (V2)
     * @request DELETE:/api/v2/news/likes
     * @secure
     */
    v2NewsLikesDelete: (
      request: ModelsRemoveNewsLikeRequest,
      params: RequestParams = {}
    ) =>
      this.request<Record<string, string>, any>({
        path: `/api/v2/news/likes`,
        method: 'DELETE',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get list of news with pagination and optional filters
     *
     * @tags News V2
     * @name V2NewsList
     * @summary List news (V2)
     * @request GET:/api/v2/news
     */
    v2NewsList: (
      query?: {
        /** Filter from date (RFC3339 format) */
        from_date?: string
        /**
         * Limit for pagination
         * @format int64
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number
        /**
         * Offset for pagination
         * @format int64
         * @min 0
         * @default 0
         */
        offset?: number
        /** Filter by tag */
        tag?: string
        /** Filter to date (RFC3339 format) */
        to_date?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListNewsResponse, any>({
        path: `/api/v2/news`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get all news main page items with news details
     *
     * @tags News V2
     * @name V2NewsMainPageList
     * @summary Get all news main page items (V2)
     * @request GET:/api/v2/news/main-page
     */
    v2NewsMainPageList: (
      query?: {
        /**
         * Limit for pagination
         * @format int32
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number
        /**
         * Offset for pagination
         * @format int32
         * @min 0
         * @default 0
         */
        offset?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsGetAllNewsMainPageResponse, any>({
        path: `/api/v2/news/main-page`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Unique tags of published news, for the section filter panel
     *
     * @tags News V2
     * @name V2NewsTagsList
     * @summary List news tags (V2)
     * @request GET:/api/v2/news/tags
     */
    v2NewsTagsList: (params: RequestParams = {}) =>
      this.request<ModelsListNewsTagsResponse, any>({
        path: `/api/v2/news/tags`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description List notifications for the authenticated user
     *
     * @tags Notifications V2
     * @name V2NotificationsList
     * @summary List notifications
     * @request GET:/api/v2/notifications
     * @secure
     */
    v2NotificationsList: (
      query?: {
        /** Max results (1-100) */
        limit?: number
        /** Offset for pagination */
        offset?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ModelsListNotificationsResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/notifications`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Mark all notifications as read for the authenticated user
     *
     * @tags Notifications V2
     * @name V2NotificationsReadAllCreate
     * @summary Mark all notifications as read
     * @request POST:/api/v2/notifications/read-all
     * @secure
     */
    v2NotificationsReadAllCreate: (params: RequestParams = {}) =>
      this.request<ModelsMarkAllAsReadResponse, ModelsCompleteActivityRequest>({
        path: `/api/v2/notifications/read-all`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Mark a single notification as read
     *
     * @tags Notifications V2
     * @name V2NotificationsReadCreate
     * @summary Mark notification as read
     * @request POST:/api/v2/notifications/{id}/read
     * @deprecated
     * @secure
     */
    v2NotificationsReadCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, ModelsCompleteActivityRequest>({
        path: `/api/v2/notifications/${id}/read`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Server-Sent Events stream for real-time notifications. Max 3 concurrent connections per user.
     *
     * @tags Notifications V2
     * @name V2NotificationsSseList
     * @summary Notifications SSE stream
     * @request GET:/api/v2/notifications/sse
     * @secure
     */
    v2NotificationsSseList: (params: RequestParams = {}) =>
      this.request<string, ModelsCompleteActivityRequest>({
        path: `/api/v2/notifications/sse`,
        method: 'GET',
        secure: true,
        ...params
      }),

    /**
     * @description Get count of unread notifications
     *
     * @tags Notifications V2
     * @name V2NotificationsUnreadCountList
     * @summary Get unread notification count
     * @request GET:/api/v2/notifications/unread-count
     * @secure
     */
    v2NotificationsUnreadCountList: (params: RequestParams = {}) =>
      this.request<ModelsUnreadCountResponse, ModelsCompleteActivityRequest>({
        path: `/api/v2/notifications/unread-count`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Save user's email for receiving notifications
     *
     * @tags Notifier V2
     * @name V2NotifierEmailCreate
     * @summary Save email for notifications (V2)
     * @request POST:/api/v2/notifier/email
     */
    v2NotifierEmailCreate: (
      request: ModelsSaveEmailRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSaveEmailResponse, any>({
        path: `/api/v2/notifier/email`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Points V2
     * @name V2PointsTransactionsDetail
     * @summary Single points transaction of the authenticated fan
     * @request GET:/api/v2/points/transactions/{id}
     * @secure
     */
    v2PointsTransactionsDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsPointsTransactionEntry, ModelsCompleteActivityRequest>(
        {
          path: `/api/v2/points/transactions/${id}`,
          method: 'GET',
          secure: true,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags Points V2
     * @name V2PointsTransactionsList
     * @summary Points transaction history for the authenticated fan
     * @request GET:/api/v2/points/transactions
     * @secure
     */
    v2PointsTransactionsList: (
      query?: {
        /** credit | debit */
        direction?: string
        /** RFC3339 */
        from?: string
        /** 0-based page */
        page?: number
        /** page size (default 50) */
        page_size?: number
        /** exact journal source (donate, activity, task_completion, swap_out, ...) */
        source_type?: string
        /** completed */
        status?: string
        /** RFC3339 */
        to?: string
        /** category: conversion | accrual */
        type?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsPointsTransactionsResponse, any>({
        path: `/api/v2/points/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Complete a quest activity and earn PTS. Supports various activity types including daily login, combo, poll, quiz, fan support, social follow, weekly mission, video watching, and gameplay
     *
     * @tags Quest V2
     * @name V2QuestActivityCompleteCreate
     * @summary Complete an activity (V2)
     * @request POST:/api/v2/quest/activity/complete
     * @deprecated
     * @secure
     */
    v2QuestActivityCompleteCreate: (
      request: ModelsCompleteActivityRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsCompleteActivityResponse, any>({
        path: `/api/v2/quest/activity/complete`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieve the authenticated player's quests grouped by type (daily, weekly, season). Each quest includes title, description, target count, current progress, and PTS reward
     *
     * @tags Quest V2
     * @name V2QuestPlayerQuestsList
     * @summary Get player quests (V2)
     * @request GET:/api/v2/quest/player/quests
     * @deprecated
     * @secure
     */
    v2QuestPlayerQuestsList: (params: RequestParams = {}) =>
      this.request<ModelsGetPlayerQuestsResponse, any>({
        path: `/api/v2/quest/player/quests`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Reroll a quest by paying PTS to get a new quest. The cost increases with each reroll. Returns the reroll cost, next reroll cost, and success status
     *
     * @tags Quest V2
     * @name V2QuestRerollCreate
     * @summary Reroll a quest (V2)
     * @request POST:/api/v2/quest/reroll
     * @deprecated
     * @secure
     */
    v2QuestRerollCreate: (
      request: ModelsRerollQuestRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsRerollQuestResponse, any>({
        path: `/api/v2/quest/reroll`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieve information about the current active season including start date, end date, and status
     *
     * @tags Quest V2
     * @name V2QuestSeasonCurrentList
     * @summary Get current season (V2)
     * @request GET:/api/v2/quest/season/current
     * @deprecated
     */
    v2QuestSeasonCurrentList: (params: RequestParams = {}) =>
      this.request<ModelsSeasonResponse, any>({
        path: `/api/v2/quest/season/current`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description List users invited by the authenticated user via fan referral link
     *
     * @tags Referrals V2
     * @name V2ReferralsMeInvitedList
     * @summary List fan referrals
     * @request GET:/api/v2/referrals/me/invited
     * @secure
     */
    v2ReferralsMeInvitedList: (
      query?: {
        /** Max results (1-100, default 20) */
        limit?: number
        /** Offset for pagination */
        offset?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ModelsListFanReferralsResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/referrals/me/invited`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get or create the fan referral link for the authenticated user
     *
     * @tags Referrals V2
     * @name V2ReferralsMeLinkList
     * @summary Get fan referral link
     * @request GET:/api/v2/referrals/me/link
     * @secure
     */
    v2ReferralsMeLinkList: (params: RequestParams = {}) =>
      this.request<
        ModelsFanReferralLinkResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/referrals/me/link`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get referral statistics for the authenticated user
     *
     * @tags Referrals V2
     * @name V2ReferralsMeStatsList
     * @summary Get fan referral stats
     * @request GET:/api/v2/referrals/me/stats
     * @secure
     */
    v2ReferralsMeStatsList: (params: RequestParams = {}) =>
      this.request<
        ModelsFanReferralStatsResponse,
        ModelsCompleteActivityRequest
      >({
        path: `/api/v2/referrals/me/stats`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Active sport types with names in the requested locale (Lang header). scope=requestable additionally returns INACTIVE entries for the Requested Club form and needs authentication.
     *
     * @tags SportTypes
     * @name V2SportTypesList
     * @summary List sport types dictionary
     * @request GET:/api/v2/sport-types
     */
    v2SportTypesList: (
      query?: {
        /** requestable */
        scope?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsSportTypesResponse, any>({
        path: `/api/v2/sport-types`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns the all-time count of completed challenges (successful Watch/Share tasks from the tasks service). Publicly accessible, no JWT. Served from Redis cache with a short TTL; a tasks-service outage degrades gracefully to the configured fallback so the endpoint never returns 5xx.
     *
     * @tags Entries V2
     * @name V2StatsChallengesList
     * @summary Completed challenges counter for Fans Landing (V2)
     * @request GET:/api/v2/stats/challenges
     */
    v2StatsChallengesList: (params: RequestParams = {}) =>
      this.request<ModelsChallengesStatsResponse, any>({
        path: `/api/v2/stats/challenges`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns aggregated platform counters rendered in the public landing pages (active fans, countries covered, completed challenges, total Arena Points, active clubs). Publicly accessible, no JWT. Response is served from Redis cache with a short TTL; backing-service failures degrade gracefully to configured fallbacks so the endpoint never returns 5xx.
     *
     * @tags Entries V2
     * @name V2StatsPlatformList
     * @summary Platform-wide stats for Fans Landing (V2)
     * @request GET:/api/v2/stats/platform
     */
    v2StatsPlatformList: (params: RequestParams = {}) =>
      this.request<ModelsPlatformStatsResponse, any>({
        path: `/api/v2/stats/platform`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Projects the latest attempt on an action task: UI status (IN_PROGRESS | VERIFYING | SUCCESS | FAILED), step states (pending | done | not_required), the server-side deadline and the failure reason.
     *
     * @tags Tasks V2
     * @name V2TasksActionAttemptDetail
     * @summary Get the fan's action attempt (V2)
     * @request GET:/api/v2/tasks/{task_id}/action/attempt
     * @secure
     */
    v2TasksActionAttemptDetail: (taskId: string, params: RequestParams = {}) =>
      this.request<ModelsActionAttemptResponse, any>({
        path: `/api/v2/tasks/${taskId}/action/attempt`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Issues a tracking link for the chosen store. First call moves the attempt from reserved to in_progress; switching the store later just overwrites the recorded choice.
     *
     * @tags Tasks V2
     * @name V2TasksActionStoreLinkCreate
     * @summary Get an action task store link (V2)
     * @request POST:/api/v2/tasks/{task_id}/action/store-link
     * @secure
     */
    v2TasksActionStoreLinkCreate: (
      taskId: string,
      request: ModelsActionStoreLinkRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsActionStoreLinkResponse, any>({
        path: `/api/v2/tasks/${taskId}/action/store-link`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Paginated list of tasks. Auth optional — guests and CLUB / AGENT tokens see the same unpersonalized list; only USER tokens get the per-fan filters (freezes, already-claimed, retry-flag).
     *
     * @tags Tasks V2
     * @name V2TasksAvailableList
     * @summary List available tasks (V2)
     * @request GET:/api/v2/tasks/available
     */
    v2TasksAvailableList: (
      query?: {
        /** Split by retry state: omit = both, true = only fan's retryable, false = exclude them */
        only_retry?: boolean
        /**
         * Page number (0-based)
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number
        /** Lifecycle slice of the showcase: ACTIVE (default) or SOON (scheduled, not reservable yet) */
        status?: 'ACTIVE' | 'SOON'
        /** Filter by task type */
        type?: 'watch' | 'share' | 'action'
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListAvailableTasksResponse, any>({
        path: `/api/v2/tasks/available`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Paginated leaderboard of fans inside a single campaign, ranked by total views accumulated across success rows. Public — no authentication required.
     *
     * @tags Tasks V2
     * @name V2TasksCampaignsLeaderboardDetail
     * @summary Get campaign leaderboard (V2)
     * @request GET:/api/v2/tasks/campaigns/{campaign_id}/leaderboard
     */
    v2TasksCampaignsLeaderboardDetail: (
      campaignId: string,
      query?: {
        /**
         * Page number (0-based)
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsGetCampaignLeaderboardResponse, any>({
        path: `/api/v2/tasks/campaigns/${campaignId}/leaderboard`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Paginated list of the fan's terminal task_progress rows (success / failed) sorted by completed_at DESC.
     *
     * @tags Tasks V2
     * @name V2TasksClosedList
     * @summary Get my closed tasks (V2)
     * @request GET:/api/v2/tasks/closed
     * @secure
     */
    v2TasksClosedList: (
      query?: {
        /**
         * Page number (0-based)
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number
        /** Filter by task type */
        type?: 'watch' | 'share' | 'action'
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListTaskProgressResponse, any>({
        path: `/api/v2/tasks/closed`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Paginated list of the fan's active task_progress rows (reserved / moderation / moderation_error / in_progress).
     *
     * @tags Tasks V2
     * @name V2TasksMyList
     * @summary Get my active tasks (V2)
     * @request GET:/api/v2/tasks/my
     * @secure
     */
    v2TasksMyList: (
      query?: {
        /**
         * Page number (0-based)
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number
        /**
         * Page size
         * @format int32
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number
        /** Filter by task type */
        type?: 'watch' | 'share' | 'action'
      },
      params: RequestParams = {}
    ) =>
      this.request<ModelsListTaskProgressResponse, any>({
        path: `/api/v2/tasks/my`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Watch path: caller reports watched / total seconds. Service transitions to success when the ratio meets the configured threshold; otherwise the call is a no-op.
     *
     * @tags Tasks V2
     * @name V2TasksProgressCompleteWatchCreate
     * @summary Complete a Watch task (V2)
     * @request POST:/api/v2/tasks/progress/{task_progress_id}/complete-watch
     * @secure
     */
    v2TasksProgressCompleteWatchCreate: (
      taskProgressId: string,
      body: ModelsCompleteWatchTaskRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsCompleteWatchTaskResponse, any>({
        path: `/api/v2/tasks/progress/${taskProgressId}/complete-watch`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Atomic reservation. Watch tasks jump straight to in_progress; Share tasks land in reserved.
     *
     * @tags Tasks V2
     * @name V2TasksProgressCreate
     * @summary Reserve a task (V2)
     * @request POST:/api/v2/tasks/{task_id}/progress
     * @secure
     */
    v2TasksProgressCreate: (taskId: string, params: RequestParams = {}) =>
      this.request<ModelsReserveTaskResponse, any>({
        path: `/api/v2/tasks/${taskId}/progress`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Share path: caller posts the URL of the published content. Service transitions the row from reserved to moderation.
     *
     * @tags Tasks V2
     * @name V2TasksProgressSubmitUrlCreate
     * @summary Submit a Share task URL (V2)
     * @request POST:/api/v2/tasks/progress/{task_progress_id}/submit-url
     * @secure
     */
    v2TasksProgressSubmitUrlCreate: (
      taskProgressId: string,
      body: ModelsSubmitTaskURLRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsSubmitTaskURLResponse, any>({
        path: `/api/v2/tasks/progress/${taskProgressId}/submit-url`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get current timer
     *
     * @tags Timer V2
     * @name V2TimersList
     * @summary Get timer (V2)
     * @request GET:/api/v2/timers
     */
    v2TimersList: (params: RequestParams = {}) =>
      this.request<ModelsTimerResponse, any>({
        path: `/api/v2/timers`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Fire-and-forget. Forwards the DSP postback (event=0) for the tracking token ($!{tid}) so the ad system can count the visit. No authentication. Call it on landing-page load. Always returns 204.
     *
     * @tags tracking
     * @name V2TrackingVisitList
     * @summary Track a landing-page visit
     * @request GET:/api/v2/tracking/visit
     */
    v2TrackingVisitList: (
      query: {
        /** Tracking token ($!{tid}) captured from the landing URL */
        token: string
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v2/tracking/visit`,
        method: 'GET',
        query: query,
        ...params
      }),

    /**
     * @description Get user balance by user ID
     *
     * @tags Users V2
     * @name V2UsersBalanceDetail
     * @summary Get user balance (V2)
     * @request GET:/api/v2/users/{id}/balance
     */
    v2UsersBalanceDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsGetUserBalanceResponse, any>({
        path: `/api/v2/users/${id}/balance`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get user details by ID with full info (roles, agent, club)
     *
     * @tags Users V2
     * @name V2UsersDetail
     * @summary Get user by ID (V2)
     * @request GET:/api/v2/users/{id}
     */
    v2UsersDetail: (id: string, params: RequestParams = {}) =>
      this.request<ModelsUserFullInfoResponse, any>({
        path: `/api/v2/users/${id}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Generate a presigned URL for uploading an image
     *
     * @tags Users V2
     * @name V2UsersMeGenerateImageUploadUrlCreate
     * @summary Generate image upload URL (V2)
     * @request POST:/api/v2/users/me/generate-image-upload-url
     */
    v2UsersMeGenerateImageUploadUrlCreate: (
      request: ModelsGenerateImageUploadURLRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsGenerateImageUploadURLResponse, any>({
        path: `/api/v2/users/me/generate-image-upload-url`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Get current user details from JWT token with full info (roles, agent, club)
     *
     * @tags Users V2
     * @name V2UsersMeList
     * @summary Get current user (V2)
     * @request GET:/api/v2/users/me
     * @secure
     */
    v2UsersMeList: (params: RequestParams = {}) =>
      this.request<ModelsUserFullInfoResponse, any>({
        path: `/api/v2/users/me`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Update user profile with avatar and banner URLs
     *
     * @tags Users V2
     * @name V2UsersMeUpdate
     * @summary Update user (V2)
     * @request PUT:/api/v2/users/me
     * @secure
     */
    v2UsersMeUpdate: (
      request: ModelsUpdateUserRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v2/users/me`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Register a new user/agent/club using a referral code with avatar and banner URLs
     *
     * @tags Users V2
     * @name V2UsersRegisterByReferralCreate
     * @summary Register by referral code (V2)
     * @request POST:/api/v2/users/register-by-referral
     * @deprecated
     */
    v2UsersRegisterByReferralCreate: (
      request: ModelsRegisterByReferralCodeRequest,
      params: RequestParams = {}
    ) =>
      this.request<ModelsRegisterByReferralCodeResponse, any>({
        path: `/api/v2/users/register-by-referral`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Server-to-server delivery endpoint for AppsFlyer Push API events. The path secret authenticates the sender; an invalid secret returns 404 with no details. The body is forwarded to the tasks service as is and acknowledged immediately; processing is asynchronous.
     *
     * @tags Webhooks V2
     * @name V2WebhooksAppsflyerCreate
     * @summary AppsFlyer Push API webhook
     * @request POST:/api/v2/webhooks/appsflyer/{secret}
     */
    v2WebhooksAppsflyerCreate: (secret: string, params: RequestParams = {}) =>
      this.request<ModelsCompleteActivityRequest, any>({
        path: `/api/v2/webhooks/appsflyer/${secret}`,
        method: 'POST',
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
  healthz = {
    /**
     * @description Check if service is healthy
     *
     * @tags Health
     * @name HealthzList
     * @summary Health check
     * @request GET:/healthz
     */
    healthzList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/healthz`,
        method: 'GET',
        type: ContentType.Json,
        ...params
      })
  }
  readyz = {
    /**
     * @description Check if service is ready to accept traffic
     *
     * @tags Health
     * @name ReadyzList
     * @summary Readiness check
     * @request GET:/readyz
     */
    readyzList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/readyz`,
        method: 'GET',
        type: ContentType.Json,
        ...params
      })
  }
  startup = {
    /**
     * @description Check if service is starting up correctly
     *
     * @tags Health
     * @name StartupList
     * @summary Startup health check
     * @request GET:/startup
     */
    startupList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/startup`,
        method: 'GET',
        type: ContentType.Json,
        ...params
      })
  }
}
